import { t } from "@lingui/macro";
import React, { useMemo } from "react";

import { HStack, Text } from "@whoosh/design-system/src/components/primitive";
import { getTimeUntilDateString } from "@whoosh/utilities/src/dates";

export type EventStatusType =
  | "CONFIRMED"
  | "CLOSED"
  | "COMPLETE"
  | "DRAFT"
  | "FULL"
  | "PENDING"
  | "SIGNUP_AVAILABLE"
  | "WAITLIST_AVAILABLE"
  | "ON_WAITLIST";

type EventStatusProps = {
  eventStatus: EventStatusType;

  opensAt?: string | null;
  spotsAvailable?: number | null;
};

export const EventStatusNew = ({
  eventStatus,
  spotsAvailable,
  opensAt,
}: EventStatusProps) => {
  const opensAtFormatted = opensAt ? getTimeUntilDateString(opensAt) : null;

  const statusText = useMemo(() => {
    switch (eventStatus) {
      case "CLOSED":
        return t`Closed`;
      case "COMPLETE":
        return t`Event Complete`;
      case "FULL":
        return t`At Capacity`;
      case "PENDING":
        return opensAtFormatted ? `${t`Opens`} ${opensAtFormatted}` : "";
      case "SIGNUP_AVAILABLE":
        return spotsAvailable
          ? `${t`Signup Available`} (${spotsAvailable} ${
              spotsAvailable > 1 ? t`Spots Available` : t`Spot Available`
            })`
          : t`Signup Available`;
      case "WAITLIST_AVAILABLE":
        return t`Waitlist Available`;
      case "CONFIRMED":
        return t`Confirmed`;
      case "ON_WAITLIST":
        return t`On Waitlist`;
      case "DRAFT":
      default:
        return null;
    }
  }, [eventStatus, opensAtFormatted, spotsAvailable]);

  if (!statusText) {
    return null;
  }

  return (
    <HStack>
      <Text variant="mainMicro" color="text-secondary">
        {statusText}
      </Text>
    </HStack>
  );
};
